import PropTypes from 'prop-types';
import React, { Component } from 'react';

import http from '../shared/http';
import { Partner } from '../partners/partner';
import { getCurrent } from '../user';

import AdTypeMainMenu from './AdTypeMainMenu';
import AdTypeVideoMenu from './AdTypeVideoMenu';
import AdTypeNativeMenu from './AdTypeNativeMenu';
import AdTypeIsiMenu from './AdTypeIsiMenu';

const ACTIVE_MENU_MAP = {
  isi: AdTypeIsiMenu,
  main: AdTypeMainMenu,
  video: AdTypeVideoMenu,
  native: AdTypeNativeMenu
};

class AdTypeMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentMenu: 'main',
      partner: null,
      currentUser: null
    };
    this.onSelectMenu = this.onSelectMenu.bind(this);
    this.fetchPartner = this.fetchPartner.bind(this);
    this.fetchCurrentUser = this.fetchCurrentUser.bind(this);
    this.readyToRender = this.readyToRender.bind(this);
  }

  componentDidMount() {
    this.fetchPartner();
    this.fetchCurrentUser();
  }

  onSelectMenu(newMenu) {
    this.setState({
      currentMenu: newMenu
    });
  }
  fetchPartner() {
    const search = new URLSearchParams(window.location.search);
    const subdomain = search.get('subdomain');
    let url = '';
    if (subdomain) {
      url = `/partners/by_subdomain?subdomain=${subdomain}`;
    } else {
      url = '/partners/by_subdomain';
    }

    http.get(url).then(
      function(response) {
        const partner = new Partner(response.data);
        partner.adTypes = partner.ad_types;
        this.setState({ partner: partner });
      }.bind(this)
    );
  }

  fetchCurrentUser() {
    getCurrent().then(user => this.setState({ currentUser: user }));
  }

  readyToRender() {
    return this.state.currentUser && this.state.partner;
  }

  render() {
    if (!this.readyToRender()) {
      return null;
    }

    const ActiveMenu = ACTIVE_MENU_MAP[this.state.currentMenu];

    return (
      <div className="ad-type-menu">
        <ActiveMenu
          $state={this.props.$state}
          onSelectMenu={this.onSelectMenu}
          partner={this.state.partner}
          currentUser={this.state.currentUser}
        />
      </div>
    );
  }
}

AdTypeMenu.propTypes = {
  $state: PropTypes.object.isRequired
};

export default AdTypeMenu;
